/**
 * Featured Items Configuration
 * This file contains the featured items for the restaurant homepage
 * Can be easily replaced with API calls in the future
 */

export const featuredItems = [
  {
    id: 1,
    name: 'Classic Burger',
    description: 'Juicy beef patty with fresh vegetables and special sauce',
    price: 12.99,
    currency: '$',
    rating: 4.8,
    reviewCount: 245,
    prepTime: '15-20 min',
    image: 'burger.png',
    category: 'burgers',
    tags: ['bestseller', 'popular'],
    available: true,
    order: 1,
  },
  {
    id: 2,
    name: 'Pepperoni Pizza',
    description: 'Traditional Italian pizza with premium pepperoni and mozzarella',
    price: 18.99,
    currency: '$',
    rating: 4.9,
    reviewCount: 189,
    prepTime: '20-25 min',
    image: 'pizza.png',
    category: 'pizza',
    tags: ['bestseller', 'italian'],
    available: true,
    order: 2,
  },
  {
    id: 3,
    name: 'Crispy Chicken',
    description: 'Golden fried chicken with secret spices and herbs',
    price: 10.99,
    currency: '$',
    rating: 4.7,
    reviewCount: 156,
    prepTime: '10-15 min',
    image: 'chiken.png',
    category: 'fastfood',
    tags: ['popular', 'spicy'],
    available: true,
    order: 3,
  },
  {
    id: 4,
    name: 'Chocolate Sundae',
    description: 'Rich chocolate ice cream with toppings and whipped cream',
    price: 6.99,
    currency: '$',
    rating: 4.9,
    reviewCount: 203,
    prepTime: '5 min',
    image: 'grilled.png',
    category: 'desserts',
    tags: ['bestseller', 'sweet'],
    available: true,
    order: 4,
  },
];

/**
 * Get featured items from API (placeholder for future implementation)
 * @returns {Promise<Array>} Array of featured items
 */
export const getFeaturedItemsFromAPI = async () => {
  try {
    // Future API call: const response = await api.get('/featured-items');
    // return response.data;
    
    // For now, return static data
    return new Promise((resolve) => {
      setTimeout(() => resolve(featuredItems), 100);
    });
  } catch (error) {
    console.error('Error fetching featured items:', error);
    return featuredItems;
  }
};

/**
 * Get available featured items only
 * @returns {Array} Array of available featured items
 */
export const getAvailableFeaturedItems = () => {
  return featuredItems.filter(item => item.available);
};

/**
 * Get featured item by ID
 * @param {number} id - Item ID
 * @returns {Object|null} Featured item object or null
 */
export const getFeaturedItemById = (id) => {
  return featuredItems.find(item => item.id === id) || null;
};

/**
 * Get featured items by category
 * @param {string} category - Category name
 * @returns {Array} Array of featured items in category
 */
export const getFeaturedItemsByCategory = (category) => {
  return featuredItems.filter(item => item.category === category);
};

/**
 * Get featured items sorted by order
 * @returns {Array} Array of sorted featured items
 */
export const getSortedFeaturedItems = () => {
  return [...featuredItems].sort((a, b) => a.order - b.order);
};

/**
 * Get bestseller featured items
 * @returns {Array} Array of bestseller items
 */
export const getBestsellerItems = () => {
  return featuredItems.filter(item => item.tags.includes('bestseller'));
};

export default featuredItems;
